/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class IcalService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get iCal Events
     * Get iCal Events
     * @param key
     * @returns string
     * @throws ApiError
     */
    public getICalEvents(
        key: string,
    ): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/ical/{key}',
            path: {
                'key': key,
            },
        });
    }
}
